import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";
import { PurchaseOrder } from "../interfaces/PurchaseOrder";

// GET all purchase orders
export const getPurchaseOrders = (params = {}) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/purchase-orders`,{ params })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};

// CREATE new purchase order
export const createPurchaseOrder = (payload: PurchaseOrder) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/purchase-orders`, camelToSnake(payload))
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};

// GET purchase order by ID
export const getPurchaseOrderById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/purchase-orders/${id}`)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};

// UPDATE purchase order
export const updatePurchaseOrder = (id: number | string, payload: PurchaseOrder) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/purchase-orders/${id}`, camelToSnake(payload))
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};

// UPDATE purchase order STATUS 
export const updatePurchaseOrderStatus = (
  id: number | string,
  status: 'draft' | 'pending' | 'paid' | 'cancelled'
) => {
  return new Promise((resolve, reject) => {
    api
      .patch(`${BASE_URL}/api/v1/purchase-orders/${id}/status`, {
        status
      })
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
};


